import { divConfirmationNouveau, ouvre } from "../../utils/dom.mjs";

export function nouveauTexte() {
	ouvre(divConfirmationNouveau);
}
